/* Constants */
import * as types from '../constants'
/* API */
import { checkUserStatus, getProfile } from 'api/users'
/* Configs */
import Keycloak from 'keycloak-js'
import { userLocalStorage } from 'config/local_storage'
/* Utils */
import Emitter from 'utils/Emitter'

const initializers = {
  actions: [],
  types: {},
}
;['INIT_SET_CURRENT_USER'].forEach(name => {
  initializers.types[name.toUpperCase()] = `APP_${name}`
  initializers.actions.push({
    type: initializers.types[name.toUpperCase()],
  })
})

export function setTheme(value) {
  return {
    payload: value,
    type: types.SET_THEME,
  }
}
export function setToken(value) {
  return {
    payload: value,
    type: types.SET_TOKEN,
  }
}
export function setPaymentData(value) {
  return {
    payload: value,
    type: types.SET_PAYMENT_DATA,
  }
}
export function setKeycloakData(value) {
  return {
    payload: value,
    type: types.SET_KEYCLOAK_USER_DATA,
  }
}
export function setProfile(value) {
  return {
    payload: value,
    type: types.SET_PROFILE,
  }
}

export const setShowAlert = ({ message, severity }) => ({ payload: { message, severity }, type: types.SET_SHOW_ALERT })

export const initializeCurrentUser = () => dispatch => {
  const keycloak = Keycloak(window.APP_CONFIG.KEYCLOAK_CONFIG)
  keycloak.init({ checkLoginIframe: false }).then(authenticated => {
    if (!authenticated) {
      return keycloak.login({ locale: 'en' })
    }
    Emitter.on('lOGGED_OUT', newValue => keycloak.logout())
    keycloak.loadUserProfile().then(() => {
      dispatch(setToken(keycloak.token))

      checkUserStatus(keycloak.subject).then(res => {
        const user = (({ username, firstName, lastName, email }) => ({
          authenticated,
          email,
          firstName,
          keycloak,
          lastName,
          username,
          ...res,
        }))(keycloak.profile)

        dispatch(setKeycloakData(user))
        userLocalStorage.set('user', user)
        dispatch(setShowAlert({ message: 'Successfully fetched data', severity: 'success' }))
      })

      getProfile(keycloak.subject)
        .then(res => {
          const userProfile = (({ username, firstName, lastName, email }) => ({
            authenticated,
            email,
            firstName,
            keycloak,
            lastName,
            username,
            ...res,
          }))(keycloak.profile)
          dispatch(setProfile(userProfile))
          userLocalStorage.set('user', userProfile)
        })
        .catch(error =>
          dispatch(
            setShowAlert({
              message: `${error?.response?.message || 'Server is not responding...'}`,
              severity: 'error',
            }),
          ),
        )
    })
  })
}

const resetStore = { type: types.SIGN_OUT }

export { initializers, resetStore }
